import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import styles from './SortableHeader.module.css';
import { SortDirection } from '../../../utils/constants/enums';

interface ISortableHeaderProps {
  text?: ReactNode;
  sortField?: string;
  sortDirection?: SortDirection;
  active?: boolean;
  onClick: (sortField: string) => void;
}

export const SortableHeader = ({
  text = '',
  sortField = '',
  sortDirection = SortDirection.ASCENDING,
  active = false,
  onClick
}: ISortableHeaderProps) => {
  let className = active ? styles.sortableHeaderActive : styles.sortableHeader;
  if (sortField === '') className = styles.notSortableHeader;

  const clickHandler = (sortField: string) => {
    if (sortField === '' || !onClick) return;
    onClick(sortField);
  };

  return (
    <th scope="col" className={className} onClick={() => clickHandler(sortField)}>
      <span className={styles.sortableLabel}>
        <span>{text}</span>
        {active && (
          <span className={styles.sortableArrow}>
            <FontAwesomeIcon
              icon={sortDirection === SortDirection.ASCENDING ? faChevronUp : faChevronDown}
            />
          </span>
        )}
      </span>
    </th>
  );
};
export default SortableHeader;
